/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Mouse position",
  "description": "Displays your mouse x/y position above the stage in the editor.",
  "credits": [
    {
      "name": "Jeffalo"
    }
  ],
  "dynamicEnable": true,
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": false
};
export default manifest;
